import { BreadcrumbGroup } from "@amzn/awsui-components-react"
import MainLayout from "pmsa-polaris/components/MainLayout"
import { useNavigate } from "react-router-dom"
import { routeParams } from "routes"

import FormContent from "./FormContent"
import toolsTopics from "./tools-topics"

const Profile: React.FC = () => {
  const navigate = useNavigate()

  return (
    <MainLayout
      contentType="form"
      toolsTopics={toolsTopics}
      breadcrumbs={
        <BreadcrumbGroup
          items={[
            { text: "Home", href: routeParams.home() },
            { text: "Profile", href: "#" },
          ]}
          onFollow={(e) => {
            e.preventDefault()
            navigate(e.detail.href)
          }}
        />
      }
    >
      <FormContent />
    </MainLayout>
  )
}

export default Profile
